<template>
  <div class="stat-body">
    <div v-if="loading" class="text-medium-emphasis py-2">불러오는 중…</div>
    <template v-else>
      <div class="stat-row">
        <span class="stat-row__label">🍀 행운 (luck)</span>
        <span class="stat-row__value">{{ luckText }}</span>
      </div>
      <div class="stat-row">
        <span class="stat-row__label">🍖 최대 배고픔</span>
        <span class="stat-row__value">{{ hungerMax }}</span>
      </div>
      <div class="stat-row">
        <span class="stat-row__label">⚡ 최대 에너지</span>
        <span class="stat-row__value">{{ energyMax }}</span>
      </div>

      <div class="fav">
        <div class="fav__head">
          <span class="fav__title">😋 좋아하는 음식</span>
          <a class="fav__exam" @click="goExam">검사하러 가기 ›</a>
        </div>
        <div v-if="!favorites.length" class="text-medium-emphasis" style="font-size: 13px">없음</div>
        <div v-else class="fav__list">
          <div v-for="(f, i) in favorites" :key="i" class="fav__chip" :class="{ hidden: !f.reveal }">
            <template v-if="f.reveal">
              <img v-if="f.imageUrl" :src="f.imageUrl" class="fav__img" />
              <span v-else class="fav__emoji">{{ f.emoji }}</span>
              <span class="fav__name">{{ f.name }}</span>
            </template>
            <template v-else>
              <span class="fav__emoji">❓</span>
              <span class="fav__name">???</span>
            </template>
          </div>
        </div>
        <div class="fav__hint">병원에서 검사하면 알아낼 수 있어요</div>
      </div>

      <div class="fav">
        <div class="fav__head">
          <span class="fav__title">🧸 좋아하는 장난감</span>
          <a class="fav__exam" @click="goExam">검사하러 가기 ›</a>
        </div>
        <div v-if="!favoriteToys.length" class="text-medium-emphasis" style="font-size: 13px">없음</div>
        <div v-else class="fav__list">
          <div v-for="(f, i) in favoriteToys" :key="i" class="fav__chip" :class="{ hidden: !f.reveal }">
            <template v-if="f.reveal">
              <img v-if="f.imageUrl" :src="f.imageUrl" class="fav__img" />
              <span v-else class="fav__emoji">{{ f.emoji }}</span>
              <span class="fav__name">{{ f.name }}</span>
            </template>
            <template v-else>
              <span class="fav__emoji">❓</span>
              <span class="fav__name">???</span>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import SupabaseApi from "@/api/SupabaseApi";

export default {
  name: "StatPanel",
  data() {
    return {
      loading: true,
      luck: 0.05,
      hungerMax: 100,
      energyMax: 100,
      favorites: [], // 좋아하는 음식 [{ foodId, reveal, name, emoji, imageUrl }]
      favoriteToys: [], // 좋아하는 장난감 [{ toyId, reveal, name, emoji, imageUrl }]
    };
  },
  computed: {
    luckText() {
      return `${(this.luck * 100).toFixed(1)}%`;
    },
  },
  methods: {
    goExam() {
      this.$router.push("/pet/hospital/favorite");
    },
  },
  async created() {
    try {
      const agg = (await SupabaseApi.PetAgg.fetch()) || {};
      const vital = agg.vital || {};
      const stat = agg.stat || {};
      const soul = agg.soul || {};
      this.hungerMax = vital.hunger_max ?? 100;
      this.energyMax = vital.energy_max ?? 100;
      this.luck = stat.luck_float ?? 0.05;
      this.favorites = (soul.favorite_foods || []).map((f) => ({
        foodId: f.food_id,
        reveal: f.reveal,
        name: f.name,
        emoji: f.emoji,
        imageUrl: f.image_url,
      }));
      this.favoriteToys = (soul.favorite_toys || []).map((f) => ({
        toyId: f.toy_id,
        reveal: f.reveal,
        name: f.name,
        emoji: f.emoji,
        imageUrl: f.image_url,
      }));
    } catch (e) {
      console.error("StatPanel load failed", e);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.stat-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 2px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.stat-row__label {
  font-size: 14px;
  font-weight: 600;
}
.stat-row__value {
  font-size: 15px;
  font-weight: 800;
  color: #6750a4;
}
.fav {
  margin-top: 14px;
}
.fav__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.fav__title {
  font-size: 14px;
  font-weight: 700;
}
.fav__exam {
  font-size: 13px;
  font-weight: 700;
  color: #4a9e8f;
  cursor: pointer;
}
.fav__exam:hover {
  text-decoration: underline;
}
.fav__list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.fav__chip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(103, 80, 164, 0.1);
  font-size: 13px;
  font-weight: 600;
}
.fav__chip.hidden {
  background: rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.5);
}
.fav__img {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  object-fit: cover;
}
.fav__emoji {
  font-size: 18px;
}
.fav__hint {
  margin-top: 8px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}
</style>
